const BASE_URL = process.env.REACT_APP_API_URL;

const API = {
  auth: {
    login: `${BASE_URL}/Auth/Login`,
    register: `${BASE_URL}/Auth/Register`,
    getUserByEmail: (email) => `${BASE_URL}/Auth/GetUserByEmail/${email}`,
    forgetPassword : `${BASE_URL}/Auth/forget-password/request`,
    confirmPassword : `${BASE_URL}/Auth/forget-password/confirm`
  },

  candidate: {
     register : `${BASE_URL}/Hiring/Candidate/register`,
     login : `${BASE_URL}/Hiring/Candidate/login`,
     get : `${BASE_URL}/Hiring/Candidate/get-by-id/{candidateId}`,
     getJobPostings : (candidateId) => `${BASE_URL}/Hiring/JobApplicant/get-by-candidate/${candidateId}`,
     create : `${BASE_URL}/Hiring/Candidate/set-password`,
     forgot : `${BASE_URL}/Hiring/Candidate/forget-password-request`,
     forgotConfirm : `${BASE_URL}/Hiring/Candidate/forget-password-confirm`
  },

  designation: {
    getAll: `${BASE_URL}/Designation/with-count/Lookup`,
    getRank: (level) => `${BASE_URL}/Designation/RankOptions/${level}`,
    create: `${BASE_URL}/Designation/Create`,
    lookupByLevels: `${BASE_URL}/Designation/Lookup/by-levels`,
    getAllByLevelsCount: (level) => `${BASE_URL}/Designation/with-count/Lookup?Level=${level}`

  },


    
  announcement: {
    add: `${BASE_URL}/Announcement/Create`,
    edit:  `${BASE_URL}/Announcement/Edit`,
    delete: (id) => `${BASE_URL}/Announcement/Delete/${id}`,
    getAll: `${BASE_URL}/Announcement/GetAll`,
  },

  domains : {
    getList : `${BASE_URL}/DomainKnowledges`,
  },

  reports: {
    getHiringReport: (departmentId) =>
      departmentId ?  `${BASE_URL}/Hiring/JobPosting/Get-Report?departmentId=${departmentId}`
    :  `${BASE_URL}/Hiring/JobPosting/Get-Report`,
    getJobApplicantReport: `${BASE_URL}/Hiring/JobApplicant/Get-Report`,
    getOfferLetterReport: (departmentId) =>
      departmentId
        ? `${BASE_URL}/Hiring/Contract/Get-Report?departmentId=${departmentId}`
        : `${BASE_URL}/Hiring/Contract/Get-Report`,
    getExpenseReport: (departmentId, month = null, year = null) => {
      let url = `${BASE_URL}/ExpenseManagement/report/get-by-department?DepartmentId=${departmentId}`;
      if (month) url += `&month=${month}`;
      if (year) url += `&year=${year}`;
      return url;
    },
    getExpenseReportSupervisor: (month = null, year = null) => {
      let url = `${BASE_URL}/ExpenseManagement/report/get-by-supervisor`;
      if (month) url += `&month=${month}`;
      if (year) url += `&year=${year}`;
      return url;
    },
    getAttendanceReport: (departmentId = 1, month = null, year = null) => {
      let url = `${BASE_URL}/Attendance/Department-Attendance-By-MonthYear?DepartmentId=${departmentId}`;
      if (month !== null && month !== "") url += `&Month=${month}`;
      if (year !== null && year !== "") url += `&Year=${year}`;
      return url;
    },

    leaveRequestReport: (departmentId, month = null, year = null) => {
      let url = `${BASE_URL}/LeaveRequest/Get-By-Department?DepartmentId=${departmentId}`;
      if (month !== null && month !== "") {
        url += `&Month=${month}`;
      }
      if (year !== null && year !== "") {
        url += `&Year=${year}`;
      }
      return url;
    },

    getEmployeesBySkills: `${BASE_URL}/Employee/Get-By-SkillSet`,
    getDepartmentPerfomance: (departmentId) => `${BASE_URL}/PerformanceEvaluation/hr/departments/${departmentId}/reviews/analytics`
  },

  skills: {
    getSkillsByEmployee: (employeeId) => `${BASE_URL}/Skills/Employee/${employeeId}`,
    getAvailableSkills: `${BASE_URL}/Skills/employee/Available-Skills`,
    addList: `${BASE_URL}/Skills/Employee/AddList`,
    getList: `${BASE_URL}/Skills/Get-List`,
    // Per Mudassir (May-24): JobPosting form now uses JobTitle-scoped skill
    // APIs. First returns the JobTitle's default/required skills (shown as
    // readonly chips). Second returns remaining department skills the
    // recruiter can add as extras (the JobTitle defaults are excluded so
    // duplicates are prevented at selection time). BE auto-merges defaults
    // + extras on JobPosting create/edit — request schema is unchanged.
    getJobTitleSkills: (jobTitleId) =>
      `${BASE_URL}/Skills/jobtitle/${jobTitleId}`,
    getAvailableSkillsForJobTitle: (jobTitleId) =>
      `${BASE_URL}/Skills/jobtitle/${jobTitleId}/available-skills`,
    createOrGet: `${BASE_URL}/Skills/create-or-get`,
  },

  // In your api/endpoints.js
  performanceReview: {
    getPerformanceReviews: (employeeId) =>
      `${BASE_URL}/PerformanceEvaluation/Employee/Performance-Reviews?employeeId=${employeeId}`,
    createPerformanceReview: `${BASE_URL}/PerformanceEvaluation/create`,
    getPreviousReview: (employeeId) =>
      `${BASE_URL}/PerformanceEvaluation/Get-Previous-Evaluation?employeeId=${employeeId}`,
    getLatestReviews: (departmentId) =>
      `/PerformanceEvaluation/hr/departments/${departmentId}/latest-reviews`,
  },

  permissionRoles: {
    set: `${BASE_URL}/PermissionRoles/manager`, //PUTs
    getByManager: (managerId) => `${BASE_URL}/PermissionRoles/manager/${managerId}`, //GET
  },
  userInvite: {
    acceptInvite: `${BASE_URL}/UserInvite/Accept-Invite`,
  },

  attendance: {
    addWorkingHrs: `${BASE_URL}/Attendance/Working-Hours/Create`, // updated
    getActiveWorkingHours: `${BASE_URL}/Attendance/Working-Hours/Get-Active`, // updated
    addCheckIn: `/Attendance/CheckIn`,
    addCheckOut: `${BASE_URL}/Attendance/CheckOut`,
    getAttendence: `${BASE_URL}/Attendance/User/GetTodayStatus`, // 403
    userAttendance: (employeeId, viewType, startDate, endDate) => {
      // Monthly view (viewType = 1)
      if (viewType === 1) {
        return `${BASE_URL}/Attendance/User-Attendance?employeeId=${employeeId}&viewType=${viewType}`;
      }

      if (startDate && endDate) {
        return `${BASE_URL}/Attendance/User-Attendance?employeeId=${employeeId}&viewType=${viewType}&startDate=${startDate}&endDate=${endDate}`;
      }

      // Fallback
      return `${BASE_URL}/Attendance/User-Attendance?employeeId=${employeeId}&viewType=${viewType}`;
    },

    getDepartmentAttendance: (departmentId, viewType = 0) =>
      `${BASE_URL}/Attendance/Department-Attendance?DepartmentId=${departmentId}&ViewType=${viewType}`,

    getDateDetail: (attendanceId) =>
      `${BASE_URL}/Attendance/Get-Detail?attendanceId=${attendanceId}`,
  },

  workLifeBalance: {
    getDepartmentMonthlyReport: (departmentId, month, year) =>
      `${BASE_URL}/Attendance/WorkLifeBalance/Department-Monthly-Report?departmentId=${departmentId}&month=${month}&year=${year}`,

    getEmployeeReport: (employeeId, month, year) =>
      `${BASE_URL}/Attendance/WorkLifeBalance/Employee-Summary?employeeId=${employeeId}&month=${month}&year=${year}`,
  },

  benefitsDependents: {
    add: `${BASE_URL}/BenefitsDependents/AddDependents`,
  },

  complaint: {
    create: `${BASE_URL}/Complaint/Create`,
    getComplaint: (complaintId) => `${BASE_URL}/Complaint/Get-By-Id/${complaintId}`,
    getMyComplaint: `${BASE_URL}/Complaint/my-complaints`,
    getUserComplaints: (complainantUserId) =>
      `${BASE_URL}/Complaint/Get-User-Complaints/${complainantUserId}`, // newly added
    updateStatus: `${BASE_URL}/Complaint/UpdateComplaintStatus`, //newly added
    getAll: (departmentId = null) =>
      departmentId
        ? `${BASE_URL}/Complaint/Get-All?departmentId=${departmentId}`
        : `${BASE_URL}/Complaint/Get-All`,
  },

  complaintType: {
    getAll: `${BASE_URL}/ComplaintType/Get-All`,
    listWithSubTypes: `${BASE_URL}/ComplaintType/List-With-Subtypes`,
    getSubTypes: (complaintTypeId) => `${BASE_URL}/ComplaintType/Get-SubTypes/${complaintTypeId}`,
  },

  user: {
    getById: (userId) => `${BASE_URL}/User/get-by-Id/${userId}`,
    getList: (departmentId) =>
      departmentId
        ? `${BASE_URL}/User/Get-List?departmentId=${departmentId}`
        : `${BASE_URL}/User/Get-List`,
  },

  userInvites: {
    userInvite : `${BASE_URL}/UserInvite/create-employee-invite`,
    getInvites : `${BASE_URL}/UserInvite/my-invites`
  },

  compliance: {
    create: `${BASE_URL}/Compliance/Create`,
    addVersion: `${BASE_URL}/Compliance/AddVersion`,
    replaceFile: `${BASE_URL}/Compliance/ReplaceFile`,

    getById: (complianceId) => `${BASE_URL}/Compliance/Get-By-Id/${complianceId}`,
    getWithVersions: (complianceId) => `${BASE_URL}/Compliance/Get-With-Versions/${complianceId}`,
    getAll: `${BASE_URL}/Compliance/Get-All`,

    // Employee-side actions
    getPendingByEmployee: `${BASE_URL}/Compliance/employee/pending`,
    getAcknowledgedByEmployee: (userId) => `${BASE_URL}/Compliance/employee/${userId}/acknowledged`,
    acknowledge: `${BASE_URL}/Compliance/employee/acknowledge`,
    getAllByEmployee: `${BASE_URL}/Compliance/employee/Get-All`,

    // File download
    download: (versionId) => `${BASE_URL}/Compliance/download?versionId=${versionId}`,
  },

  correctiveAction: {
    create: `${BASE_URL}/Complaint/CorrectiveAction/Create`,
    getListByComplaint: (complaintId) =>
      `${BASE_URL}/Complaint/CorrectiveAction/Get-By-Complaint/${complaintId}`,
    getById: (correctiveActionId) =>
      `${BASE_URL}/Complaint/CorrectiveAction/Get-By-Id/${correctiveActionId}`,
    getAll: `${BASE_URL}/Complaint/CorrectiveAction/Get-All`,
  },

  employeeEmergencyContact: {
    getEmergencyDetail: (employeeId) =>
      `${BASE_URL}/EmployeeEmergencyContact/Get-Employee-Contacts/${employeeId}`,
    addEmergencyContact: `${BASE_URL}/EmployeeEmergencyContact/Create`,
  },

  expenseManagement: {
    getEmployeeExpenses: `${BASE_URL}/ExpenseManagement/employee/list`,
    createExpenseManagementByEmp: `${BASE_URL}/ExpenseManagement/Create`,
    downloadReceipt: (expenseManagementId) =>
      `${BASE_URL}/ExpenseManagement/Download/Receipt/${expenseManagementId}`,
    downloadSheet: (expenseManagementId) =>
      `${BASE_URL}/ExpenseManagement/Download/ExpenseSheet/${expenseManagementId}`,
    getExpenseListBySupervisor: `${BASE_URL}/ExpenseManagement/supervisor/List`,
    updateStatus: `${BASE_URL}/ExpenseManagement/Update-Status`,

    delete: (expenseManagementId) =>
      `${BASE_URL}/ExpenseManagement/Expense-Termination/${expenseManagementId}`,
    //New URLs added in endpoint.js
    getList: `${BASE_URL}/ExpenseManagement/Get-List`,
  },

  hardwareAssets: {
    add: `${BASE_URL}/HardwareAssets/Add`,
    getById: (hardwareAssetId) => `${BASE_URL}/HardwareAssets/Get-By-Id/${hardwareAssetId}`,
    getEmployeeAssets: (employeeId) =>
      `${BASE_URL}/HardwareAssets/Get-Employee-Assets/${employeeId}`,
    getAll: `${BASE_URL}/HardwareAssets/Get-All`,
    update: `${BASE_URL}/HardwareAssets/Update`,
    delete: (id) => `${BASE_URL}/HardwareAssets/Delete/${id}`,
  },

  softwareAssets: {
    add: `${BASE_URL}/SoftwareAssets/Add`,
    getById: (softwareAssetId) => `${BASE_URL}/SoftwareAssets/Get-By-Id/${softwareAssetId}`,
    getEmployeeAssets: (employeeId) =>
      `${BASE_URL}/SoftwareAssets/Get-Employee-Assets/${employeeId}`,
    getAll: `${BASE_URL}/SoftwareAssets/Get-All`,
    update: `${BASE_URL}/SoftwareAssets/Update`,
    delete: (id) => `${BASE_URL}/SoftwareAssets/Delete/${id}`,
  },

  //  Hiring Process APIs
  hiringJobPosting: {
    getAllPostings: `${BASE_URL}/Hiring/JobPosting/Get-All-Postings`,
    getAll: `${BASE_URL}/Hiring/JobPosting/Get-List`,
    add: `${BASE_URL}/Hiring/JobPosting/Create`,
    update: `${BASE_URL}/Hiring/JobPosting/Edit`,
    delete: (id) => `${BASE_URL}/Hiring/JobPosting/Post-Termination/${id}`,
    getPostingById: (id) => `${BASE_URL}/Hiring/JobPosting/GetpostingById/${id}`,
    // Per Mudassir (May-20): marks a posting as Filled. Backend blocks
    // further hiring-pipeline actions once Filled; onboarding remains open.
    markAsFilled: (jobPostingId) =>
      `${BASE_URL}/Hiring/JobPosting/mark-as-filled/${jobPostingId}`,
    explore: (candidateId) =>
  candidateId
    ? `${BASE_URL}/Hiring/JobPosting/candidate/explore?candidateId=${candidateId}`
    : `${BASE_URL}/Hiring/JobPosting/candidate/explore`,

    // Internal applicant (logged-in employee) — AI-powered openings
    employeeExplore: `${BASE_URL}/Hiring/JobPosting/employee/explore`,
  },

  holiday: {
    getList: `${BASE_URL}/Holiday/Get-List`,
  },

  hiringJobApplicant: {
    apply: `${BASE_URL}/Hiring/JobApplicant/Apply`,
    getAllWithJobPosting: `${BASE_URL}/Hiring/JobApplicant/GetAll-With-JobPosting`,
    getListByPosting: (jobPostingId) =>
      `${BASE_URL}/Hiring/JobApplicant/Get-By-JobPosting/${jobPostingId}`,
    getById: (jobApplicantId) => `${BASE_URL}/Hiring/JobApplicant/Get-By-Id/${jobApplicantId}`,
    addJobApplicantAction: `/Hiring/JobApplicant/JobApplicantAction`,
    getEmailStatus: (jobApplicantId) =>
      `${BASE_URL}/Hiring/JobApplicant/GetEmailStatus?jobApplicantId=${jobApplicantId}`,
    sendEmail: `${BASE_URL}/Hiring/JobApplicant/SendEmail`,
    login: `${BASE_URL}/Hiring/JobApplicant/Login`,
    delete: (jobApplicantId) => `${BASE_URL}/Hiring/JobApplicant/Delete/${jobApplicantId}`,
    reject: (jobApplicantId) => `${BASE_URL}/Hiring/JobApplicant/Reject/${jobApplicantId}`,

    // Internal applicant (logged-in employee)
    myApplications: `${BASE_URL}/Hiring/JobApplicant/employee/my-applications`,
    // Per Swagger (confirmed by Mudassir 2026-05-20): path is /internal/apply,
    // body is multipart with jobPostingId (req), resumeFile (req), coverLetterFile (opt).
    internalApply: `${BASE_URL}/Hiring/JobApplicant/internal/apply`,
  },

  applicantTalentProfile: {
    getById: (id) => `${BASE_URL}/Hiring/ApplicantTalentProfile/${id}`,
    getByApplication: (jobApplicationId) =>
      `${BASE_URL}/Hiring/ApplicantTalentProfile/by-application/${jobApplicationId}`,
    getDetailById: (id) => `${BASE_URL}/Hiring/ApplicantTalentProfile/detail/${id}`,
    getDetailByApplication: (jobApplicationId) =>
      `${BASE_URL}/Hiring/ApplicantTalentProfile/detail/by-application/${jobApplicationId}`,
  },

  aiEvaluation: {
  getByApplication: (jobApplicationId) =>
    `${BASE_URL}/Hiring/ApplicantTalentProfile/ai-evaluation/by-application/${jobApplicationId}`,
},

  hiringInterviews: {
    proposeInterview: `${BASE_URL}/Hiring/Interview/ProposeInterviewSlots`,
    getByJobApplicantId: (jobApplicantId) =>
      `${BASE_URL}/Hiring/Interview/Get-By-JobApplicantId/${jobApplicantId}`,
    selectSchedule: `${BASE_URL}/Hiring/Interview/Applicant/Select-Schedule`,
    getEmployeeSelectedDate: (jobApplicantId) =>
      `${BASE_URL}/Hiring/Interview/Applicant/Get-Selected-Date/${jobApplicantId}`,


    getRoundsByApplication: (jobApplicationId) =>
      `${BASE_URL}/Hiring/Interview/hr/rounds/by-application/${jobApplicationId}`,
    getRoundById: (roundId) => `${BASE_URL}/Hiring/Interview/round/${roundId}`,
    proposeSlots: `${BASE_URL}/Hiring/Interview/round/propose-slots`,
    completeRound: `${BASE_URL}/Hiring/Interview/hr/round/complete`,

    // Applicant-side (career portal view)
    getApplicantRoundsByApplication: (jobApplicationId) =>
      `${BASE_URL}/Hiring/Interview/applicant/rounds/by-application/${jobApplicationId}`,
    selectSlot: `${BASE_URL}/Hiring/Interview/applicant/Select-Slot`,
  },

    feedback: {
    getById:(feedbackId) => `${BASE_URL}/Hiring/Feedback/get-by-id/${feedbackId}`,

    getByJobApplicantId: (jobApplicantId) =>
      `${BASE_URL}/Hiring/Feedback/get-by-applicant?applicantId=${jobApplicantId}`,
   
    provideFeedback: `${BASE_URL}/Hiring/Feedback/Provide-feedback`,
  },

  hiringContracts: {
    sendContracts: `${BASE_URL}/Hiring/Contract/HR/Send-Contract`,
    contractAcceptance: `${BASE_URL}/Hiring/Contract/JobApplicant/Contract-Acceptance`,
    getContractByApplicant: (jobApplicantId) =>
      `${BASE_URL}/Hiring/Contract/Get-By-Applicant/${jobApplicantId}`,
    getReceiveContractByApplicant: (jobApplicantId) =>
      `${BASE_URL}/Hiring/Contract/Received/Get-By-applicant/${jobApplicantId}`,
    getAllReceiveContracts: `${BASE_URL}/Hiring/Contract/Received/Get-All`,
    getByUserId: (employeeId) => `${BASE_URL}/Hiring/Contract/Received/Get-By-Employee/${employeeId}`,
    getByEmployeeId: (employeeId) =>
      `${BASE_URL}/Hiring/Contract/Received/Get-By-Employee/${employeeId}`,
  },

  hiringOnboardings: {
    addOnboarding: `${BASE_URL}/Hiring/Onboarding`,
    updateOnboarding: `${BASE_URL}/Hiring/Onboarding`,
    getByApplicant: (jobApplicantId) =>
      `${BASE_URL}/Hiring/Onboarding/Get-By-Applicant/${jobApplicantId}`,
 
  },

  leavePolicy: {
    addLeavePolicy: `${BASE_URL}/LeavePolicy/Create`, // no diff
    // getList: `${BASE_URL}/LeavePolicy/List`,    not used
    getCurrentYearList: `${BASE_URL}/LeavePolicy/Current-Year`, // 403
    myBalance: `${BASE_URL}/LeavePolicy/My-Balances`, // no diff
  },
  leaveRequest: {
    createLeaveRequest: `${BASE_URL}/LeaveRequest/Create`, // no diff
    getAll: `${BASE_URL}/LeaveRequest/Get-All`, // check pending
    createHRReview: `${BASE_URL}/LeaveRequest/HR/Review`, // no diff
    myRequests: `${BASE_URL}/LeaveRequest/My-Requests`, // no diff
    getPendingRequests: (departmentId = "") =>
      `${BASE_URL}/LeaveRequest/Pending-Approvals${departmentId ? `/${departmentId}` : ""}`, // updated
  },

  careerPaths : {
     getListByLookup : (departmentId) => `${BASE_URL}/CareerPath/lookup?DepartmentId=${departmentId}`,
     create : `${BASE_URL}/CareerPath/create`,
     createTransitions : `${BASE_URL}/CareerPath/transitions`,
     update: `${BASE_URL}/CareerPath/update`,
     getCareerPath : (id) => `${BASE_URL}/CareerPath/${id}`,
     getByEmployee : (employeeId) => `${BASE_URL}/CareerPath/${employeeId}/career-path`,
     getAlternativePaths : (employeeId)=> `${BASE_URL}/CareerPath/${employeeId}/career-path/alternatives`,
     // Employee-authorized endpoints (per Mudassir 2026-05-20). Use these for
     // the Employee Dashboard CareerPath pages. Same response shape as the
     // HR-side endpoints, wrapped in { isApplicable, message, data }.
     getMyCareerPath: `${BASE_URL}/CareerPath/me/career-path`,
     getMyAlternativePaths: `${BASE_URL}/CareerPath/me/career-path/alternatives`,
     getSupervisors : (employeeId, jobTitleId, isInternal = false) => {
       // isInternal flag is only relevant for the internal-applicant flow.
       // We only append it when explicitly true so the existing alternative-
       // paths flow keeps its current URL shape untouched.
       const base = `${BASE_URL}/Employee/career-paths/supervisors?employeeId=${employeeId}&jobTitleId=${jobTitleId}`;
       return isInternal ? `${base}&isInternal=true` : base;
     },
     // Career transition analytics for an internal applicant (per Mudassir 2026-05-20)
     getApplicantTransitionAnalytics: (jobApplicantId) =>
       `${BASE_URL}/CareerPath/job-applicants/${jobApplicantId}/career-transition-analytics`,
     // Internal-applicant career transition submission (per Mudassir 2026-05-20).
     // Distinct from createTransitions above — validations differ from the
     // standard alternative-paths flow.
     submitInternalTransition: `${BASE_URL}/CareerPath/internal-applications/transitions`,
  },

  jobTitle: {
    getList: (departmentId) => `${BASE_URL}/JobTitle/list?DepartmentId=${departmentId}`,
    getById: (id) => `${BASE_URL}/JobTitle/${id}`,
    create: `${BASE_URL}/JobTitle/create`,
    update: `${BASE_URL}/JobTitle/update`,
    getListByLookup: (departmentId) => `${BASE_URL}/JobTitle/lookup?departmentId=${departmentId}`,
  },

  employee: {
    create: `${BASE_URL}/Employee/Create`,
    createInvite: `${BASE_URL}/Employee/invited/create`, 
    checkWorkEmailExists: (workEmail) => `${BASE_URL}/Employee/CheckWorkEmailExists/${workEmail}`,
    supervisors: (designationId, departmentId) =>
      `${BASE_URL}/Employee/supervisors?designationId=${designationId}&departmentId=${departmentId}`,
    directReports: (supervisorId) =>
      `${BASE_URL}/Employee/direct-reports?supervisorId=${supervisorId}`,
    getAll: (departmentId, hasDocuments) => {
  let url = `${BASE_URL}/Employee/Get-All-Employees`;
  const params = [];

  if (hasDocuments !== undefined && hasDocuments !== null) {
    params.push(`hasDocuments=${hasDocuments}`);
  }

  if (departmentId) {
    params.push(`departmentId=${departmentId}`);
  }

  if (params.length > 0) {
    url += `?${params.join("&")}`;
  }

  return url;
},
    getMyEmployees: `${BASE_URL}/Employee/supervisor/direct-reports`,
    employeeGetById: (employeeId) => `${BASE_URL}/Employee/Get-by-Id/${employeeId}`,
    getMyDetail: `${BASE_URL}/Employee/my-detail`,
    getCompensations: (employeeId) => `${BASE_URL}/Compensations/employee/${employeeId}`,
    getEmployment: (employeeId) => `${BASE_URL}/Employment/employee/${employeeId}`,
    getHierDirectReports: (supervisorId) =>
      `${BASE_URL}/Employee/org-hierarchy/direct-reports?supervisorId=${supervisorId}`,
    getUserHierarchy: `${BASE_URL}/Employee/org-hierarchy`,
    getAllOverview: (departmentId) =>
      departmentId
        ? `${BASE_URL}/Employee/Get-All-Overview?departmentId=${departmentId}`
        : `${BASE_URL}/Employee/Get-All-Overview`,

    // getLastEmployeeNumber: ${BASE_URL}/Employee/GetLastEmployeeNumber,
    getPersonalIds: `${BASE_URL}/Employee/Get-Ids`,
    checkEmployeeExists: (empId) => `${BASE_URL}/Employee/Check-Exist/${empId}`,
    getPersonalInfoByPostingTitle: (jobTitle) =>
      `${BASE_URL}/Employee/Get-PersonalInfo-By-PostingTitle/${jobTitle}`,
    getAllEmployeeNumbers: ` ${BASE_URL}/Employee/Get-All-EmployeeNumbers`,
    GetWithJobById: (employeeId) => `${BASE_URL}/Employee/Get-With-Job/${employeeId}`,
    updatePersonalInfo: (personalId) => `${BASE_URL}/Employee/UpdatePersonalInfo/${personalId}`, //Unknw APi in beckend
  },

  department: {
    getList: `${BASE_URL}/Department/list`,
    getListByLookup: `${BASE_URL}/Department/lookup`,
    update: `${BASE_URL}/Department/update`,
    getByEmployeeId: (employeeId) => `${BASE_URL}/Employee/Get-By-EmployeeId/${employeeId}`,
    getById: (id) => `${BASE_URL}/Department/${id}`,
    myDepartment: `${BASE_URL}/Department/My-Department`,
    createDepartment: `${BASE_URL}/Department/create`,
    // getListByManagerFlag: `${BASE_URL}/Department/GetList-with-manager-flag`,
  },
};

export default API;
